import { render } from "./BookingPage.vue?vue&type=template&id=00459d86&scoped=true"
import script from "./BookingPage.vue?vue&type=script&lang=js"
export * from "./BookingPage.vue?vue&type=script&lang=js"

import "./BookingPage.vue?vue&type=style&index=0&id=00459d86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00459d86"]])

export default __exports__